import { createTeamResourceContext } from './createTeamResourceContext'
import useRegistriesResources from '../shared/resources/api/v1/admin/docker/useRegistriesResources'

const { Provider: RegistriesProvider, useHook: useRegistries } = createTeamResourceContext({
  name: 'Registries',
  useResources: useRegistriesResources,
  responseKey: 'registries',
  lookups: [{ key: 'registriesById', field: 'id' }],
})

export { RegistriesProvider, useRegistries }
